import { code } from "@spscommerce/utils";

export const SpsFieldsetExamples = {
    basic: {
        label: "Basic Fieldsets",
        description: "info about basic fieldsets",
        examples: {
            basic: {
                template: code`
                    <form [formGroup]="form">
                        <sps-fieldset legend="Fieldset Legend" formGroupName="basicFieldset">
                            <div class="sps-row">
                                <div class="col-4">
                                    <sps-label for="fsTextA">Input A</sps-label>
                                    <sps-text-input placeholder="Enter a thing" formControlName="fsTextA"></sps-text-input>
                                </div>
                                <div class="col-4">
                                    <sps-label for="fsTextB">Input B</sps-label>
                                    <sps-text-input placeholder="Enter a thing" formControlName="fsTextB"></sps-text-input>
                                </div>
                                <div class="col-4">
                                    <sps-label for="fsRadio">Radio</sps-label>
                                    <sps-input-group formGroupName="fsRadioGroup">
                                        <sps-radio-button value="a" label="Option A"
                                            formControlName="fsRadio">
                                        </sps-radio-button>
                                        <sps-radio-button value="b" label="Option B"
                                        formControlName="fsRadio">
                                        </sps-radio-button>
                                    </sps-input-group>
                                </div>
                            </div>
                        </sps-fieldset>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                    basicFieldset: this._formBuilder.group({
                                        fsTextA: [],
                                        fsTextB: [],
                                        fsRadioGroup: this._formBuilder.group({
                                            fsRadio: ["a"]
                                        })
                                    })
                            });
                        }
                    }
                `
            }
        }
    },
    optional: {
        label: "Optional Fieldsets",
        description: "info about optional fieldsets",
        examples: {
            optional: {
                template: code`
                    <sps-fieldset legend="Fieldset Legend" optional [enabled]="false">
                        <div class="sps-row">
                            <div class="col-4">
                                <sps-label for="fsoTextA">Input A</sps-label>
                                <sps-text-input placeholder="Enter a thing" name="fsoTextA"></sps-text-input>
                            </div>
                            <div class="col-4">
                                <sps-label for="fsoTextB">Input B</sps-label>
                                <sps-text-input placeholder="Enter a thing" name="fsoTextB"></sps-text-input>
                            </div>
                        </div>
                    </sps-fieldset>
                `,
                class: code`
                    class DemoComponent {
                        form: FormGroup;
                    }
                `
            }
        }
    },
    nested: {
        label: "Nested Fieldsets",
        description: "info about nested fieldsets",
        examples: {
            nested: {
                template: code`
                        <form [formGroup]="form">
                            <sps-fieldset legend="Fieldset Legend" formGroupName="fieldsetWithNested">
                                <div class="sps-row">
                                    <div class="col-4">
                                        <sps-label for="fsText">Input</sps-label>
                                        <sps-text-input placeholder="Enter a thing" formControlName="fsText"></sps-text-input>
                                    </div>
                                </div>
                                <sps-fieldset legend="Nested Fieldset" formGroupName="fsNested">
                                    <div class="sps-row">
                                        <div class="col-3">
                                            <sps-label for="fsnRadioGroup">Radio</sps-label>
                                            <sps-input-group formGroupName="fsnRadioGroup">
                                                <sps-radio-button value="a" label="Option A" formControlName="fsnRadio">
                                                </sps-radio-button>
                                                <sps-radio-button value="b" label="Option B"
                                                    formControlName="fsnRadio">
                                                </sps-radio-button>
                                            </sps-input-group>
                                        </div>
                                    </div>
                                    <sps-fieldset legend="Doubly Nested Fieldset" formGroupName="fsNested2">
                                        <div class="sps-row">
                                            <div class="col-4">
                                                <sps-label for="fsn2Text">Input</sps-label>
                                                <sps-text-input placeholder="Enter a thing" formControlName="fsn2Text"></sps-text-input>
                                            </div>
                                        </div>
                                    </sps-fieldset>
                                </sps-fieldset>
                            </sps-fieldset>
                        </form>
                    `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                fieldsetWithNested: this._formBuilder.group({
                                    fsText: [],
                                    fsNested: this._formBuilder.group({
                                        fsnRadioGroup: this._formBuilder.group({
                                            fsnRadio: ["b"]
                                        }),
                                        fsNested2: this._formBuilder.group({
                                            fsn2Text: []
                                        })
                                    })
                                })
                            });
                        }
                    }
                `
            }
        }
    },
    optionalNested: {
        label: "Optional Nested Fieldsets",
        description: "info about optional nested fieldsets",
        examples: {
            optionalNested: {
                template: code`
                    <sps-fieldset legend="Fieldset Legend">
                        <div class="sps-row">
                            <div class="col-4">
                                <sps-label for="fsText">Input</sps-label>
                                <sps-text-input placeholder="Enter a thing" name="fsText"></sps-text-input>
                            </div>
                        </div>
                        <sps-fieldset optional legend="Nested Fieldset">
                            <div class="sps-row">
                                <div class="col-4">
                                    <sps-label for="fsnText">Input</sps-label>
                                    <sps-text-input placeholder="Enter a thing" name="fsnText"></sps-text-input>
                                </div>
                            </div>
                        </sps-fieldset>
                    </sps-fieldset>
                            `,
                class: code`
                        class DemoComponent implements OnInit {
                            constructor(private _formBuilder: FormBuilder) {}
                            form: FormGroup;
                            ngOnInit() {
                                this.form = this._formBuilder.group({
                                    fieldsetWithNested: this._formBuilder.group({
                                        fsText: [],
                                        fsNested: this._formBuilder.group({
                                            fsnRadioGroup: this._formBuilder.group({
                                                fsnRadio: ["b"]
                                            }),
                                            fsNested2: this._formBuilder.group({
                                                fsn2Text: []
                                            })
                                        })
                                    })
                                });
                            };
                        }
                    `
            }
        }
    },
    validationOnField: {
        label: "Validation on a Field",
        description: "info about validation on fields",
        examples: {
            validationOnField: {
                template: code`
                    <form [formGroup]="form">
                        <sps-fieldset legend="Fieldset Legend" formGroupName="fieldsetWithFieldValidation">
                            <div class="sps-row">
                                <div class="col-4">
                                    <sps-label for="requiredText">Input</sps-label>
                                    <sps-text-input placeholder="Enter a thing" formControlName="requiredText"></sps-text-input>
                                </div>
                            </div>
                        </sps-fieldset>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                fieldsetWithFieldValidation: this._formBuilder.group({
                                    requiredText: ["", Validators.required]
                                })
                            });
                            this.form.get("fieldsetWithFieldValidation.requiredText").markAsDirty();
                        };
                    }
                `
            }
        }
    },
    validationOnFieldset: {
        label: "Validation on a Fieldset",
        description: "info about validation on a fieldset",
        examples: {
            validationOnFieldset: {
                template: code`
                    <form [formGroup]="form">
                        <sps-fieldset legend="Fieldset Legend" formGroupName="fieldsetValidationExample">
                            <div class="sps-row">
                                <div class="col-4">
                                    <sps-label for="fsText">Input</sps-label>
                                    <sps-text-input placeholder="Enter a thing" formControlName="fsText"></sps-text-input>
                                </div>
                            </div>
                            <sps-fieldset legend="Nested Fieldset" formGroupName="nestedValidatedFieldset">
                                <sps-fieldset-error>If you choose Option B, you must select at least one color.</sps-fieldset-error>
                                    <div class="sps-row">
                                        <div class="col-3">
                                            <sps-label for="fsnRadioGroup">Radio</sps-label>
                                            <sps-input-group formGroupName="fsnRadioGroup">
                                            <sps-radio-button value="a" label="Option A"
                                                formControlName="fsnRadio">
                                            </sps-radio-button>
                                            <sps-radio-button value="b" label="Option B"
                                                formControlName="fsnRadio">
                                            </sps-radio-button>
                                        </sps-input-group>
                                    </div>
                                    <div class="col-9">
                                        <sps-label for="colors">Colors</sps-label>
                                        <sps-input-group formArrayName="colors">
                                            <sps-checkbox *ngFor="let color of colorOptions; let i = index"
                                                [label]="color" [formControlName]="i">
                                            </sps-checkbox>
                                        </sps-input-group>
                                    </div>
                                </div>
                            </sps-fieldset>
                        </sps-fieldset>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        form: FormGroup;
                        colorOptions = ["Red", "Orange", "Yellow", "Green", "Blue", "Indigo", "Violet"];

                        constructor(private _formBuilder: FormBuilder) {}

                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                fieldsetValidationExample: this._formBuilder.group({
                                    fsText: [],
                                    nestedValidatedFieldset: this._formBuilder.group(
                                        {
                                            fsnRadioGroup: this._formBuilder.group({
                                                fsnRadio: ["b"]
                                            }),
                                            colors: this._formBuilder.array(this.colorOptions.map(() => []))
                                        },
                                        { validator: this.exampleFieldsetValidator }
                                    )
                                })
                            });
                            this.form
                            .get(
                                "fieldsetValidationExample.nestedValidatedFieldset.fsnRadioGroup.fsnRadio"
                            )
                            .markAsDirty();
                        }

                        exampleFieldsetValidator(control: AbstractControl): ValidationErrors | null {
                            if (control.value.fsnRadioGroup.fsnRadio === "b") {
                                if (control.value.colors.filter(Boolean).length === 0) {
                                    return {
                                        exampleFieldset: true
                                    };
                                }
                            }
                            return null;
                        }
                    }
                `
            }
        }
    }
};
